<!-- eslint-disable no-unused-vars -->

<template>
  <v-container class="containerStyle">
    <center>
      <div class="container cam-istruction">
        <div class="icon_holder pb-2">
          <v-avatar color="primary-bg-light-1" size="20">
            <!-- <v-icon dark size="14">videocam</v-icon> -->
            <i class="mdi mdi-camera"></i>
          </v-avatar>
        </div>
        <h4 class="grey--text text--darken-2 mb-0 mt-1">
          This is a liveness test
        </h4>

        <p class="grey--text text--darken-2 mb-0 mt-1">
          1. Make sure there is <b>sufficient light</b>
        </p>

        <p class="grey--text text--darken-2 mb-0 mt-1">
          2. Please follow the following instructions while capturing your live
          photo.<br />
          3. <b>Move your face and Blink your eyes </b>as instructed during
          photo capturing.<br />
        </p>
        <v-layout
          row
          justify-center
          class="pt-4 mt-2"
          style="background-color: transparent !important"
        >
          <v-flex xs12 sm12 md6>
            <v-layout row wrap>
              <v-flex xs4>
                <v-avatar color="#fff">
                  <img :src="gesture3" />
                </v-avatar>

                <p>Turn your head RIGHT and back straight</p>
              </v-flex>
              <v-flex xs4>
                <v-avatar color="#fff">
                  <img :src="gesture1" />
                </v-avatar>
                <p>Blink once</p>
              </v-flex>
              <v-flex xs4>
                <v-avatar color="#fff">
                  <img :src="gesture2" />
                </v-avatar>
                <p>Turn your head LEFT and back straight</p>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <p class="grey--text text--darken-2 mb-0 mt-1">
          The test will begin in
        </p>
      </div>

      <div
        class="logo_container countdownContainer"
        style="bottom: 0px; width: 100%"
      >
        <div class="round_button" style="top:23px; color">
          <div class="heading bold white_text countdown font-35">10</div>
        </div>
      </div>

      <div class="logo_container procDiv logoContainerStyle">
        <v-layout row class="widthMax livenessSuccessNextBtn">
          <!-- style="padding-top: 2rem" -->

          <v-flex xs8 sm8 md6>
            <router-link to="/kycPage" class="finalButton">
              <v-btn color="primary-btn" dark block class="text-none"
                >Next
              </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </div>
    </center>
    <center class="video-upl-res">
      <div class="cards procDiv container hide customError" id="procDiv">
        <div class="facingPage facingPageContainer">
          <h4 class="grey--text text--darken-2 mb-0 mt-1">Thank you</h4>
          <p class="grey--text text--darken-2 mb-0 mt-1" id="proc_message">
            Please wait while your video<br />
            is being uploaded.
          </p>
          <p class="grey--text text--darken-2 mb-0 mt-1" id="done_message">
            You have successfully passed the Liveliness test.
          </p>
          <p class="grey--text text--darken-2 mb-0 mt-1" id="done_message1">
            Please proceed by clicking Next.
          </p>
        </div>
      </div>
      <div class="bottomcontainer procDiv hide one"></div>
      <div class="bottomcontainer procDiv hide two"></div>
      <div class="bottomcontainer procDiv hide three"></div>
    </center>

    <div id="videoElement">
      <center>
        <video id="vid1" class="" muted playsinline autoplay></video>
      </center>
    </div>
    <span id="location locationStyle"></span>
    <center>
      <!-- <v-avatar color="secondary-bg" id="dot" class="hide" style="position:fixed; left:45%; top:48%;bottom: 50%; z-index:500"> -->
      <v-avatar size="80" color="#FF8200" id="dot" class="hide dotStyle">
        <!-- <img src="" id="blinkmimage" alt="blink image" ><br/><br/> -->
        <b><p class="color-black" v-if="isFirstImg">BLINK ONCE</p></b>
        <b> <p class="color-black" v-if="isSecondImg">TURN LEFT</p></b>
        <b> <p class="color-black" v-if="isThirdImg">TURN RIGHT</p></b>
      </v-avatar>
    </center>

    <button id="btnStart" class="hide">START</button>
    <button id="btnStop" class="hide">STOP</button>

    <div
      class="processingDiv"
      v-bind:class="{
        show:
          processLoader == 1 ||
          processLoader == 2 ||
          processLoader == 3 ||
          processLoader == 4 ||
          processLoader == 5,
      }"
    >
      <v-layout row wrap justify-center>
        <v-flex md4 class="text-xs-center">
          <v-stepper class="elevation-0 width100Perc" v-model="processLoader">
            <v-stepper-items>
              <v-stepper-content step="1">
                <img
                  :src="processLoader1"
                  class="stepper-vector center-block"
                />
                <h3 class="text-primary">
                  {{ kycMessage }}
                </h3>
              </v-stepper-content>
              <v-stepper-content step="2">
                <img
                  :src="processLoader2"
                  class="stepper-vector center-block"
                />
                <h3 class="text-primary">
                  {{ kycMessage }}
                </h3>
              </v-stepper-content>
              <v-stepper-content step="3">
                <img
                  :src="processLoader3"
                  class="stepper-vector center-block"
                />
                <h3 class="text-primary">
                  {{ kycMessage }}
                </h3>
              </v-stepper-content>
              <v-stepper-content step="4">
                <img
                  :src="processLoader4"
                  class="stepper-vector center-block"
                />
                <h3 class="text-primary">
                  {{ kycMessage }}
                </h3>
              </v-stepper-content>
              <v-stepper-content step="5">
                <img
                  :src="processLoader5"
                  class="stepper-vector center-block"
                />
                <h3 class="text-primary">
                  {{ kycMessage }}
                </h3>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog
      scrollable
      persistent
      v-model="DocumentUploadFailureDailog"
      width="800"
      class="LivenessErrorDisplay"
    >
      <v-card>
        <v-card-title primary-title>
          <v-flex xs12 sm12 class="text-xs-center">
            <h2 class="commen-heading font-14">Liveliness Status</h2>
          </v-flex>
        </v-card-title>
        <v-card-text class="text-xs-center pt-0">
          <h3 class="grey--text text--darken-2 font-14">
            <!-- Sorry you didn't pass the liveliness test. Please follow the instructions carefully while re-upload. -->
            {{ livenessFailureMsg }}
          </h3>
        </v-card-text>
        <v-card-text class="pt-0">
          <v-container fluid class="pt-0" persistent>
            <v-layout row justify-center>
              <v-flex xs6 sm6 md6 class="pr-1">
                <v-btn
                  block
                  color="primary-btn"
                  dark
                  class="text-none"
                  @click="reupload()"
                  >Re-Upload</v-btn
                >
              </v-flex>
              <v-flex xs6 sm6 md6 class="pl-1" v-if="proceedwithoutreupload">
                <v-btn
                  color="grey lighten-2"
                  block
                  class="text-none"
                  @click="proceedwithoutreuploadMethod()"
                  >Proceed Anyway</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import router from "@/router";
import axios from "axios";

import { db, externalURL } from "@/sunidhiapp";
// import axios from 'axios';
import $ from "jquery";
import processLoader1 from "@/assets/images/process_loader-1.gif";
import processLoader2 from "@/assets/images/process_loader-2.gif";
import processLoader3 from "@/assets/images/process_loader-3.gif";
import processLoader4 from "@/assets/images/process_loader-4.gif";
import processLoader5 from "@/assets/images/process_loader-5.gif";
import gesture1 from "@/assets/images/LivenessGIF-1.gif";
import gesture2 from "@/assets/images/LivenessGIF-2.gif";
import gesture3 from "@/assets/images/LivenessGIF-3.gif";
import { getSessionId } from '@/services/sessionservice';
// var imgElement = $('<img/>').attr('src', '@/assets/images/cut_out.png').height($("#videoElement").height()).width($('.facingPage').width()).attr("id", "cutout");
var imgElement = $("<img/>")
  .attr("src", require("@/assets/images/cut_out.png")) // Use require to properly resolve the path
  .height($("#videoElement").height())
  .width($(".facingPage").width())
  .attr("id", "cutout");

// Append the imgElement to the desired parent element
$("#videoElement").append(imgElement);

export default {
  name: "livenessCheck",
  data: function () {
    return {
      isIosDevice: "False",
      eyeblink: "",
      headleft: "",
      headright: "",
      Firststop: 0,
      Secondstop: 0,
      ThirdStop: 0,
      firstimg: "",
      secondimg: "",
      thirdimg: "",
      processLoader: 6,
      kycMessage: "",
      DocumentUploadFailureDailog: false,
      proceedwithoutreupload: false,
      livenessuploadcount: 0,
      livenessFailureMsg: false,
      isFirstImg: true,
      isSecondImg: false,
      isThirdImg: false,
      processLoader1: processLoader1,
      processLoader2: processLoader2,
      processLoader3: processLoader3,
      processLoader4: processLoader4,
      processLoader5: processLoader5,
      gesture1: gesture1,
      gesture2: gesture2,
      gesture3: gesture3,
    };
  },
  mounted: async function () {
    sessionStorage.removeItem('DUPLICATE_SESSION_HANDLED')
    this.$sunidhi.logoutBtnDisp = true;
    $("#proc_message").hide();
    $("#done_message").hide();
    $(".procDiv").hide();
    var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
    // console.log('genzdata', genzdata);
    if (genzdata != null || genzdata.length > 0) {
      if (typeof genzdata[0].token == "undefined") {
        this.userid = "0";
      } else {
        this.userid = genzdata[0].token;
      }
    } else {
      this.userid = "0";
    }
    // await getLanguageSelected(this.userid);

    this.onready(this.userid);
    await this.getlivenessOption(this.userid);
    await this.getlivenessuploadcount();
    // await langSelected(selectedLanguage);
  },
  methods: {
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    update_count() {
      // debugger
      var count = $(".countdown").html() - 1;
      $(".countdown").html(count);
      clearTimeout();
      if (count > 0) {
        if (count == 4) {
          if (this.isIOS()) {
            $("#vid1").height(window.innerHeight).width(window.innerWidth);
          }
          $("#videoElement").show();
          // $("#vid1").show();
          // $("#videoElement").append(imgElement);

          // alert(deviceAgent)
        }
        if (count == 4) {
          $(".cam-istruction").hide();
          $(".logo_container").addClass("SetBottom");
          $("#infoDiv").css("background", "transparent");
        }

        setTimeout(this.update_count, 1000);
      } else {
        if (count == 0) {
          $(".countdownContainer").fadeOut(1000);
        }
        this.start_capture();
      }
    },
    start_capture() {
      $("#infoDiv").remove();
      $("#overlayDiv").hide();

      $("#btnStart").click();
    },
    onready(userid) {
      $(".finalButton").hide();
      console.log("ready");
      let constraintObj = {
        audio: false,
        video: {
          facingMode: "user",
          width: { min: 300 }, //, max: 1920 },
          height: { min: 400 }, //, max:1080}
        },
      };
      $(".finalButton").on("click", async function () {
        // this.$sunidhi.backbuttonpressed = false;
        await db.TbGenz.where("token")
          .equals(userid)
          .modify({ livenessuploadcount: 0 });
        // this.$sunidhi.logoutBtnDisp = 'true';
        router.push({ name: "kycPage" });
      });
      var self = this;
      // alert(navigator.mediaDevices)
      //handle older browsers that might implement getUserMedia in some way
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
        navigator.mediaDevices.getUserMedia = function (constraintObj) {
          let getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.mediaDevices.getUserMedia;
          if (!getUserMedia) {
            // alert('no user')
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          return new Promise(function (resolve, reject) {
            // alert(resolve, reject)
            getUserMedia.call(navigator, constraintObj, resolve, reject);
          });
        };
      } else {
        navigator.mediaDevices
          .enumerateDevices()
          .then((devices) => {
            devices.forEach((device) => {
              console.log(device.kind.toUpperCase(), device.label);
              //, device.deviceId
            });
          })
          .catch((err) => {
            console.log(err.name, err.message);
          });
      }
      navigator.mediaDevices
        .getUserMedia(constraintObj)
        .then(function (mediaStreamObj) {
          //connect the media stream to the first video element
          let video = document.querySelector("video");
          if ("srcObject" in video) {
            video.srcObject = mediaStreamObj;
          } else {
            //old version
            video.src = window.URL.createObjectURL(mediaStreamObj);
          }

          video.onloadedmetadata = function (ev) {
            console.log("ev", ev);
            //show in the video element what is being captured by the webcam
            video.play();
          };

          //add listeners for saving video/audio
          let start = document.getElementById("btnStart");
          console.log("start", start);
          let stop = document.getElementById("btnStop");
          let liveVid = document.getElementById("vid1");
          console.log("liveVid", liveVid);

          let mediaRecorder = new MediaRecorder(mediaStreamObj);
          let chunks = [];

          // start.addEventListener('click', function(ev){
          $("#btnStart").on("click", function (ev) {
            console.log("ev", ev);
            var str = document.getElementById("dot");

            mediaRecorder.start();
            str.classList.add("hide");

            clearTimeout();
            // console.log(new Date())
            var stops = [self.Firststop, self.Secondstop, self.ThirdStop];
            setTimeout(function () {
              self.processLoader = 1;
              self.kycMessage = "Please wait... we are uploading the video";
              clearTimeout();
              let stop = document.getElementById("btnStop");
              stop.click();
            }, 10000);
            stops.forEach(function (stop) {
              setTimeout(function () {
                clearTimeout();
                var str = document.getElementById("dot");
                var src = "./pwa/genz/Assets/";

                if (self.firstimg.includes(stop)) {
                  switch (self.firstimg.split(",")[1]) {
                    case "eyeblink":
                      src += "LivenessGIF-1.gif";
                      self.isFirstImg = true;
                      self.isSecondImg = false;
                      self.isThirdImg = false;
                      break;
                    case "headleft":
                      src += "LivenessGIF-2.gif";
                      self.isFirstImg = false;
                      self.isSecondImg = true;
                      self.isThirdImg = false;
                      break;
                    case "headright":
                      src += "LivenessGIF-3.gif";
                      self.isFirstImg = false;
                      self.isSecondImg = false;
                      self.isThirdImg = true;

                      break;
                  }
                } else if (self.secondimg.includes(stop)) {
                  switch (self.secondimg.split(",")[1]) {
                    case "eyeblink":
                      src += "LivenessGIF-1.gif";
                      self.isFirstImg = true;
                      self.isSecondImg = false;
                      self.isThirdImg = false;
                      break;
                    case "headleft":
                      src += "LivenessGIF-2.gif";
                      self.isFirstImg = false;
                      self.isSecondImg = true;
                      self.isThirdImg = false;
                      break;
                    case "headright":
                      src += "LivenessGIF-3.gif";
                      self.isFirstImg = false;
                      self.isSecondImg = false;
                      self.isThirdImg = true;
                      break;
                  }
                } else if (self.thirdimg.includes(stop)) {
                  switch (self.thirdimg.split(",")[1]) {
                    case "eyeblink":
                      src += "LivenessGIF-1.gif";
                      self.isFirstImg = true;
                      self.isSecondImg = false;
                      self.isThirdImg = false;
                      break;
                    case "headleft":
                      src += "LivenessGIF-2.gif";
                      self.isFirstImg = false;
                      self.isSecondImg = true;
                      self.isThirdImg = false;
                      break;
                    case "headright":
                      src += "LivenessGIF-3.gif";
                      console.log("blinkmimage::", src);
                      self.isFirstImg = false;
                      self.isSecondImg = false;
                      self.isThirdImg = true;
                      break;
                  }
                }
                var blinkmimage = document.getElementById("blinkmimage");
                console.log("blinkmimage::", blinkmimage);
                // blinkmimage.src = src;
                // str.style.top = '10%';
                // str.style.left = '10%';
                str.classList.remove("hide");
                setTimeout(function () {
                  clearTimeout();
                  var str = document.getElementById("dot");
                  str.classList.add("hide");
                }, 700);
              }, stop);
            });

            // console.log(mediaRecorder.state);
          });
          stop.addEventListener("click", function (ev) {
            console.log("ev::", ev);
            mediaRecorder.stop();
            $("#videoElement").hide();
            $(".procDiv").show();
            $("#done_message").hide();
            $("#procDiv").show();
            // $(".finalButton").show();
            console.log(mediaRecorder.state);
          });

          mediaRecorder.ondataavailable = function (ev) {
            chunks.push(ev.data);
          };
          mediaRecorder.onstop = async function (ev) {
            console.log("ev::", ev);
            let blob = new Blob(chunks, { type: "video/mp4;" });
            chunks = [];
            let videoURL = window.URL.createObjectURL(blob);
            console.log("videourl::", videoURL);
            var isIos = "False";

            // var deviceAgent = navigator.userAgent.toLowerCase();
            // var agentID = deviceAgent.match(/(iphone|ipod|ipad)/);
            // console.log("agentID:",agentID)
            // if (agentID) {
            //     isIos = "True";
            // }

            var platform = navigator.platform.toLowerCase();
            console.log("platform:", platform);
            if (
              platform.startsWith("iphone") ||
              platform.startsWith("ipad") ||
              platform.startsWith("ipod") ||
              platform.startsWith("mac")
            ) {
              isIos = "True";
            }

            var fd = new FormData();
            var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
            fd.append("userid", userid);
            fd.append("livevideo", blob);
            fd.append("isios", isIos);
            // fd.append("PWAUserSessionId", genzdata[0].PWAUserSessionId);
            fd.append("PWAUserSessionId", getSessionId());

            var timecount = 0;
            var timer = setInterval(function () {
              timecount++;
              switch (timecount) {
                case 1:
                  self.processLoader = 2;
                  self.kycMessage =
                    "Checking for suspicious activity in the video";
                  break;
                case 2:
                  self.processLoader = 3;
                  self.kycMessage = "Anti-spoofing filters in place";
                  break;
                case 3:
                  self.processLoader = 4;
                  self.kycMessage = "Checking for gesture accuracy";
                  break;
                case 4:
                  self.processLoader = 5;
                  self.kycMessage = "Almost done... Just a few seconds more";
                  break;
                case 5:
                  clearInterval(timer);
                // default:
                // code block
              }
            }, 3000);

            // try {
            //   $.ajax({
            //     url: externalURL + "livenesscheck/",
            //     type: "POST",
            //     data: fd,
            //     headers: {
            //       "Content-Security-Policy": "frame-ancestors 'none'",
            //       "Access-Control-Allow-Origin": "*",
            //       "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
            //       "Access-Control-Allow-Headers":
            //         "Content-Type, Cookie, Set-Cookie, Authorization,Origin, X-Requested-With,Accept",
            //       "Access-Control-Allow-Credentials": "true",
            //     },
            //     processData: false,
            //     contentType: false,
            //     success: async function (data) {
            //       console.log("Liveness Response ?", data);

            //       var validResponse = false;

            //       if (
            //         data.PWAUserSessionId === null ||
            //         data.PWAUserSessionId === "" ||
            //         data.PWAUserSessionId === undefined
            //       ) {
            //         validResponse = false;
            //       } else {
            //         validResponse = true;
            //       }
            //       console.log("Valid Response ?", validResponse);

            //       if (data) {
            //         if (data.DSAAuthenticationStatus == "01") {
            //           console.log("data", data.DSAAuthenticationStatus);
            //           self.dsaLoginErrorMsg = data.message;
            //         //   alert(data.message);
            //           setTimeout(() => {
            //             self.PreLoader = false;
            //           }, 500);

            //           $(".procDiv").hide();
            //                 self.DocumentUploadFailureDailog = true;
            //                 self.livenessFailureMsg = data.message;
            //                 clearInterval(timer);
            //   self.processLoader = 6;

            //         } else if (data.DSAAuthenticationStatus !== "01") {
            //           if (data.PWAUserSessionStatus == "expired") {
            //             setTimeout(() => {
            //               self.PreLoader = false;
            //             }, 500);
            //             this.$sunidhi.logoutBtnDisp = false;
            //             router.push({ name: "SessionTimeout" });
            //           } else if (
            //             data.PWAUserSessionStatus == "Active" &&
            //             validResponse
            //           ) {
            //             clearInterval(timer);
            //             self.processLoader = 6;
            //             if (data != null && data != undefined) {
            //               if (
            //                 data.result != null &&
            //                 data.result != undefined &&
            //                 data.result.livenessStatus != null &&
            //                 data.result.livenessStatus != undefined &&
            //                 data.result.livenessStatus
            //                   .toString()
            //                   .toLocaleLowerCase() == "true"
            //               ) {
            //                 $("#proc_message").hide();
            //                 $("#done_message").show();
            //                 var genzdata = await db.TbGenz.where("UserId")
            //                   .anyOf(1)
            //                   .toArray();
            //                 if (genzdata != null || genzdata.length > 0) {
            //                   await db.TbGenz.update(genzdata[0].PkId, {
            //                     video: blob,
            //                   });
            //                 }

            //                 $(".finalButton").show();
            //               } else {
            //                 $(".procDiv").hide();
            //                 self.DocumentUploadFailureDailog = true;
            //                 self.livenessFailureMsg = data.message;
            //               }
            //             } else {
            //               $(".procDiv").hide();
            //               self.DocumentUploadFailureDailog = true;
            //               self.livenessFailureMsg = data.message;
            //             }
            //           } else {
            //             setTimeout(() => {
            //               self.PreLoader = false;
            //             }, 1000);
            //             alert(this.$sunidhi.sessionIdErrorMsg); //errr
            //             router.push({ name: "LoginPage" });
            //           }
            //         }
            //       }
            //     },
            //     error: async function (xhr, status, error) {
            //       console.log("xhr", xhr);
            //       console.log("status", status);
            //       console.log("error", error);

            //       console.log("Error uploading video");
            //       clearInterval(timer);
            //       self.processLoader = 6;
            //       self.DocumentUploadFailureDailog = true;
            //       $(".procDiv").hide();

            //       self.livenessFailureMsg =
            //       xhr.message == undefined
            //           ? "Liveness Failed due to Internal server error. Please Try again later."
            //           : data.message;
            //       await db.TbGenz.where("token")
            //         .equals(userid)
            //         .modify({ livenessuploadcount: 0 });
            //       self.proceedwithoutreupload = false;
            //     },
            //   }).done(function (data) {
            //     console.log(data);
            //   });
            // } catch (err) {
            //   clearInterval(timer);
            //   self.processLoader = 6;
            //   $(".procDiv").hide();
            //   self.DocumentUploadFailureDailog = true;
            //   self.livenessFailureMsg = "ERROR FAILURE";
            //   self.proceedwithoutreupload = false;
            // }

            try {
              // $.ajax({
              //   url: externalURL + "livenesscheck/",
              //   type: "POST",
              //   data: fd,
              //   headers: {
              //     "Content-Security-Policy": "frame-ancestors 'none'",
              //     "Access-Control-Allow-Origin": "*",
              //     "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
              //     "Access-Control-Allow-Headers":
              //       "Content-Type, Cookie, Set-Cookie, Authorization, Origin, X-Requested-With, Accept",
              //     "Access-Control-Allow-Credentials": "true",
              //   },
              //   processData: false,
              //   contentType: false,
              //   success: async function (data) {
              //     console.log("Liveness Response:", data);

              //     let validResponse = !!data.PWAUserSessionId;
              //     console.log("Valid Response:", validResponse);

              //     if (data.DSAAuthenticationStatus === "01") {
              //       console.log("Authentication Failed:", data.message);
              //       self.dsaLoginErrorMsg = data.message;
              //       self.PreLoader = false;
              //       $(".procDiv").hide();
              //       self.DocumentUploadFailureDailog = true;
              //       self.livenessFailureMsg = data.message;
              //       clearInterval(timer);
              //       self.processLoader = 6;
              //     } else if (data.PWAUserSessionStatus === "expired") {
              //       self.PreLoader = false;
              //       self.$sunidhi.logoutBtnDisp = false;
              //       router.push({ name: "SessionTimeout" });
              //     } else if (
              //       data.PWAUserSessionStatus === "Active" &&
              //       validResponse
              //     ) {
              //       clearInterval(timer);
              //       self.processLoader = 6;
              //       if (
              //         data.result.livenessStatus.toString().toLowerCase() ===
              //         "true"
              //       ) {
              //         $("#proc_message").hide();
              //         $("#done_message").show();
              //         var genzdata = await db.TbGenz.where("UserId")
              //           .anyOf(1)
              //           .toArray();
              //         if (genzdata.length > 0) {
              //           await db.TbGenz.update(genzdata[0].PkId, {
              //             video: blob,
              //           });
              //         }
              //         $(".finalButton").show();
              //       } else {
              //         $(".procDiv").hide();
              //         self.DocumentUploadFailureDailog = true;
              //         self.livenessFailureMsg = data.message;
              //       }
              //     } else {
              //       self.PreLoader = false;
              //       alert("Sorry! Please try again."); //sessionId ErrorMsg
              //       router.push({ name: "LoginPage" });
              //     }
              //   },
              //   error: async function (xhr, status, error) {
              //     console.error("Liveness Error xhr:",  xhr);
              //     console.error("Liveness Error status:", status);
              //     console.error("Liveness Error error:",  error);
              //     clearInterval(timer);
              //     self.processLoader = 6;
              //     $(".procDiv").hide();
              //     self.DocumentUploadFailureDailog = true;
              //     self.livenessFailureMsg = "Service Unavailable due to network issue. Please try again later.";

              //     // if (xhr.status === 500) {
              //     //   self.livenessFailureMsg =
              //     //     "Internal Server Error (500): Please try again later.";
              //     // } else if (xhr.status === 504) {
              //     //   self.livenessFailureMsg =
              //     //     "Gateway Timeout (504): The server took too long to respond. Please check your internet connection and try again.";
              //     // } else if (xhr.responseJSON && xhr.responseJSON.message) {
              //     //   self.livenessFailureMsg = xhr.responseJSON.message;
              //     // } else {
              //     //   self.livenessFailureMsg =
              //     //     "Liveness Failed due to an unknown error. Please try again later.(504)";
              //     // }

              //     await db.TbGenz.where("token")
              //       .equals(userid)
              //       .modify({ livenessuploadcount: 0 });

              //     self.proceedwithoutreupload = false;
              //   },
              // }).done(function (data) {
              //   console.log("AJAX Request Done:", data);
              // });

              try {
                const response = await axios.post(
                  `${externalURL}livenesscheck/`,
                  fd,
                  {
                    headers: {
                      // "Content-Security-Policy": "frame-ancestors 'none'",
                      // "Access-Control-Allow-Origin": "*",
                      // "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
                      // "Access-Control-Allow-Headers":
                      //   "Content-Type, Cookie, Set-Cookie, Authorization, Origin, X-Requested-With, Accept",
                      // "Access-Control-Allow-Credentials": "true",
                      "Content-Type": "multipart/form-data",
                      'DSAUserId': genzdata[0].DSAUserId
                    },
                  }
                );

                console.log("Liveness Response:", response.data);
                let data = response.data;
                let validResponse = !!data.PWAUserSessionId;
                console.log("Valid Response:", validResponse);

                if (data.DSAAuthenticationStatus === "01") {
                  console.log("Authentication Failed:", data.message);
                  self.dsaLoginErrorMsg = data.message;
                  self.PreLoader = false;
                  $(".procDiv").hide();
                  self.DocumentUploadFailureDailog = true;
                  self.livenessFailureMsg = data.message;
                  clearInterval(timer);
                  self.processLoader = 6;
                } else if (data.PWAUserSessionStatus === "expired") {
                  self.PreLoader = false;
                  self.$sunidhi.logoutBtnDisp = false;
                  router.push({ name: "SessionTimeout" });
                } else if (
                  data.PWAUserSessionStatus === "Active" &&
                  validResponse
                ) {
                  clearInterval(timer);
                  self.processLoader = 6;
                  if (
                    data.result.livenessStatus.toString().toLowerCase() ===
                    "true"
                  ) {
                    $("#proc_message").hide();
                    $("#done_message").show();
                    let genzdata = await db.TbGenz.where("UserId")
                      .anyOf(1)
                      .toArray();
                    if (genzdata.length > 0) {
                      await db.TbGenz.update(genzdata[0].PkId, { video: blob });
                    }
                    $(".finalButton").show();
                  } else {
                    $(".procDiv").hide();
                    self.DocumentUploadFailureDailog = true;
                    self.livenessFailureMsg = data.message;
                  }
                } else {
                  self.PreLoader = false;
                  alert("Sorry! Please try again."); // sessionId ErrorMsg
                  router.push({ name: "LoginPage" });
                }
              } catch (error) {
                if(error === 'Duplicate session'){
                  setTimeout(() => {
                  self.PreLoader = false;
                }, 1000);
                  return;
                }
                console.error("Liveness Error:", error);
                clearInterval(timer);
                self.processLoader = 6;
                $(".procDiv").hide();
                self.DocumentUploadFailureDailog = true;

                if (error.response) {
                  switch (error.response.status) {
                    case 500:
                      self.livenessFailureMsg =
                        "Internal Server Error (500): Please try again later.";
                      break;
                    case 504:
                      self.livenessFailureMsg =
                        "Gateway Timeout (504): The server took too long to respond. Please check your internet connection and try again.";
                      break;
                    default:
                      self.livenessFailureMsg =
                        error.response.data.message ||
                        "Liveness Failed due to an unknown error. Please try again later.";
                      break;
                  }
                } else if (error.request) {
                  console.log("Request =>", error.request)
                  if (error.request.getAllResponseHeaders) {
                    console.error(
                      "Raw Headers:",
                      error.request.getAllResponseHeaders()
                    );
                  }

                  self.livenessFailureMsg =
                    "No response from server. Please check your network connection and try again.";
                } else {
                  self.livenessFailureMsg = "Unexpected error occurred.";
                }

                await db.TbGenz.where("token")
                  .equals(userid)
                  .modify({ livenessuploadcount: 0 });
                self.proceedwithoutreupload = false;
              }
            } catch (err) {
              clearInterval(timer);
              self.processLoader = 6;
              $(".procDiv").hide();
              self.DocumentUploadFailureDailog = true;
              self.livenessFailureMsg = "Unexpected error occurred.";
              self.proceedwithoutreupload = false;
            }

            var track = mediaStreamObj.getTracks()[0];
            track.stop();
          };
        })
        .catch(async function (err) {
          console.log("ERR: ", err.message);
          console.log(err.name, err.message);
          console.log("Camera blocked");
          if (err.message == "Permission denied") {
            const userResponse = confirm(
              "Camera access blocked. Please enable camera permission from the site settings and click on reset Permission button"
            );

            if (userResponse) {
              router.push({
                name: "liveness_landingPage",
                params: { userid: userid },
              });
            } else {
              router.push({
                name: "liveness_landingPage",
                params: { userid: userid },
              });
            }
          }
        });

      setTimeout(this.update_count, 1000);
    },

    gotokyc() {
      // this.$sunidhi.setbackbuttonpressed(false);
      this.$sunidhi.logoutBtnDisp = true;
      router.push({ name: "kycPage" });
    },
    async getlivenessOption(userid) {
      console.log("userid:", userid);
      var genzdata = await db.TbGenz.where("token").equals(userid).toArray();
      // var genzdata = await db.TbGenz.where("token").equals(userid.toString()).toArray();
      if (genzdata != null && genzdata.length > 0) {
        var tot = "";

        this.eyeblink =
          genzdata[0].eyeblink != null && genzdata[0].eyeblink.length > 0
            ? genzdata[0].eyeblink.split(",")
            : [];
        this.headleft =
          genzdata[0].headlefttilt != null &&
          genzdata[0].headlefttilt.length > 0
            ? genzdata[0].headlefttilt.split(",")
            : [];
        this.headright =
          genzdata[0].headrighttilt != null &&
          genzdata[0].headrighttilt.length > 0
            ? genzdata[0].headrighttilt.split(",")
            : [];

        if (this.eyeblink != null && this.eyeblink.length > 0) {
          tot = this.eyeblink.join(",");
        }

        if (this.headleft != null && this.headleft.length > 0) {
          if (tot != null && tot.length > 0) {
            tot = tot + "," + this.headleft.join(",");
          } else {
            tot = this.headleft.join(",");
          }
        }

        if (this.headright != null && this.headright.length > 0) {
          if (tot != null && tot.length > 0) {
            tot = tot + "," + this.headright.join(",");
          } else {
            tot = this.headright.join(",");
          }
        }

        if (tot != null && tot.length > 0) {
          var array = tot.split(",").sort();
          if (array != null && array.length > 0) {
            for (var i = 0; i < array.length; i++) {
              switch (i) {
                case 0:
                  this.Firststop = parseInt(array[i]) * 1000 - 100;
                  if (this.eyeblink.includes(array[i])) {
                    this.firstimg = this.Firststop + ",eyeblink";
                  } else if (this.headleft.includes(array[i])) {
                    this.firstimg = this.Firststop + ",headleft";
                  } else if (this.headright.includes(array[i])) {
                    this.firstimg = this.Firststop + ",headright";
                  }
                  break;
                case 1:
                  this.Secondstop = parseInt(array[i]) * 1000 - 100;
                  if (this.eyeblink.includes(array[i])) {
                    this.secondimg = this.Secondstop + ",eyeblink";
                  } else if (this.headleft.includes(array[i])) {
                    this.secondimg = this.Secondstop + ",headleft";
                  } else if (this.headright.includes(array[i])) {
                    this.secondimg = this.Secondstop + ",headright";
                  }
                  break;
                case 2:
                  this.ThirdStop = parseInt(array[i]) * 1000 - 100;
                  if (this.eyeblink.includes(array[i])) {
                    this.thirdimg = this.ThirdStop + ",eyeblink";
                  } else if (this.headleft.includes(array[i])) {
                    this.thirdimg = this.ThirdStop + ",headleft";
                  } else if (this.headright.includes(array[i])) {
                    this.thirdimg = this.ThirdStop + ",headright";
                  }
                  break;
              }
            }
          }
          //   console.log(dd);
        }
      }
    },

    async reupload() {
      var userid = this.userid;
      // this.$sunidhi.setbackbuttonpressed(false);
      this.processLoader = 6;
      this.livenessuploadcount += 1;
      $(".procDiv").hide();
      $("#done_message").hide();
      $("#done_message1").hide();
      await db.TbGenz.where("token")
        .equals(userid)
        .modify({ livenessuploadcount: this.livenessuploadcount });
      //window.location.reload();
      this.$sunidhi.logoutBtnDisp = true;
      this.proceedwithoutreupload = true;
      this.DocumentUploadFailureDailog = false;
      router.push({ name: "liveness_landingPage", params: { userid: userid } });
    },
    async proceedwithoutreuploadMethod() {
      var userid = this.userid;
      this.processLoader = 6;
      await db.TbGenz.where("token")
        .equals(userid)
        .modify({ livenessuploadcount: 0 });
      this.DocumentUploadFailureDailog = false;
      this.gotokyc();
    },
    async getlivenessuploadcount() {
      var userid = this.userid;
      var form = await db.TbGenz.where("token").equals(userid).toArray();
      if (form != null && form.length > 0) {
        var livenesscount =
          form[0].livenessuploadcount != null &&
          form[0].livenessuploadcount != undefined
            ? form[0].livenessuploadcount
            : 0;
        this.livenessuploadcount = livenesscount;

        if (this.livenessuploadcount > 2) {
          this.proceedwithoutreupload = true;
        }
      }
    },
  },
  // beforeRouteLeave(to, from, next) {
  //     if (this.$sunidhi.backbuttonpressed) {
  //         // if (confirm('You may have unsaved changes. Do you want to continue?')) {
  //         return next(false);
  //         //  }
  //     } else {
  //         return next();
  //     }
  // }
};
</script>

<style type="text/css" scoped>
.mdi-camera {
  color: white;
}

@media screen and (min-width: 1280px) {
  .video-upl-res {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.logoContainerStyle {
  z-index: 1;
  bottom: 100px !important;
  top: 50%;
}

.widthMax {
  width: max-content;
}

.width100Perc {
  width: 100%;
}

.dotstyle {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 500;
  height: 20vh;
}

#locationstyle {
  position: fixed;
  left: 0;
  bottom: 0;
  color: blue;
  font-size: 6;
  z-index: 5;
}

.bottomcontainer {
  background: none !important;
}
.SetBottom {
  bottom: 40px !important;
  position: absolute !important;
}

.logo_container {
  position: relative;
  bottom: 90px;
}

#videoElement {
  /* position: absolute; */
  top: 0;
  width: 100vw;
  overflow: hidden;
  display: none;
}

#videoElement video {
  object-fit: cover;
  height: 100vh !important;
  width: 100vw !important;
}

#videoElement img {
  /* width: 100vw !important;
            height: 100vh !important; */
  /* Remove the oval shape from the camera */
  width: 0% !important;
  height: 0% !important;
  position: fixed;
  top: 0;
}

#vid1 {
  position: relative;
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg); /* Safari and Chrome */
  -moz-transform: rotateY(180deg); /* Firefox */
}

.iconStyle {
  height: 63px !important;
  width: 86px !important;
}
.iconRightStyle {
  height: 61px !important;
  width: 82px !important;
}

.avatar {
  vertical-align: middle;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.v-dialog--active > .LivenessErrorDisplay {
  display: contents !important;
}
.nextBtnStyle {
  z-index: 1;
  bottom: 100px !important;
}
.width-max-content {
  width: max-content;
}
.locationIDStyle {
  position: fixed;
  left: 0;
  bottom: 0;
  color: blue;
  font-size: 6;
  z-index: 5;
}
.dotIDStyle {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 500;
  height: 20vh;
}
.color-black {
  color: black;
}
.container.cards {
  /* border-radius: 10px; */
  background: white !important;
}

.customError {
  padding-bottom: 5rem;
  margin: -1rem;
  padding: 0px !important;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.containerStyle {
  /* padding: 0px !important;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */
}

.facingPageContainer {
  padding: 4rem !important;
}
@media screen and (max-width: 1336px) {
  .livenessSuccessNextBtn {
    padding-top: 2rem;
  }
}

@media screen and (min-width: 1336px) {
  .livenessSuccessNextBtn {
    padding-top: 4rem;
  }
}
</style>
